import {parseFormula, rollFormula} from '../../../../components/dice/dice-formula';
import type {Character} from './character';
import type {CharacterState} from './character-state';

const SHORT_REST_RECHARGES = ['shortRest', 'shortOrLongRest'];

export function shortRestPatch(character: Character, state: CharacterState): Partial<CharacterState> {
	const spentUses = {...state.spentUses};
	for (const use of character.limitedUses) {
		if (use.recharge && SHORT_REST_RECHARGES.includes(use.recharge)) delete spentUses[use.key];
		else if (use.regainsOnShortRest) spentUses[use.key] = Math.max(0, use.spent - use.regainsOnShortRest);
	}
	const {pact: _pactSlots, ...spentSpellSlots} = state.spentSpellSlots;
	return {spentUses, spentSpellSlots};
}

export function longRestPatch(character: Character, state: CharacterState): Partial<CharacterState> {
	const {maxHitPoints: _maxHitPoints, maxHitPointsBonus: _maxHitPointsBonus, ...overrides} = state.overrides;
	const spentUses: Record<string, number> = {};
	for (const use of character.limitedUses) {
		if (use.recharge !== 'dawn' || !use.regain || !use.spent) continue;
		const regained = rollFormula(parseFormula(use.regain)).total;
		if (use.spent > regained) spentUses[use.key] = use.spent - regained;
	}
	return {
		spentUses,
		spentSpellSlots: {},
		spentHitDice: {},
		hitPoints: {spent: 0, temporary: 0, temporarySpent: 0},
		deathSaves: {successes: 0, failures: 0},
		exhaustion: Math.max(0, (state.exhaustion || 0) - 1),
		activeSpells: [],
		overrides,
	};
}
